module.exports = __webpack_public_path__ + "img/sprint-empty-doing.527855cc.svg";